<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 12</h1>
          <div class="text-left">
            <p>London, got a bus</p>
            <a href="/uk/12London.jpeg"><img alt="London" class="uitk-image-media" src="12London.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/12London-2.jpeg"><img alt="London" class="uitk-image-media" src="12London-2.jpeg" style="width: 17%; height: auto;"></a>
            <a href="/uk/12Bus.jpeg"><img alt="London" class="uitk-image-media" src="12Bus.jpeg" style="width: 17%; height: auto;"></a>
            <p>East is South</p>
            <a href="/uk/12EastIsSouth.jpeg"><img alt="London" class="uitk-image-media" src="12EastIsSouth.jpeg" style="width: 17%; height: auto;"></a>
          </div>      
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
      ////
    }
  }
  </script>